module.exports = __webpack_public_path__ + "img/userWomanWithSpace.e16d1ded.svg";